import { IKnmRemark } from '../interfaces/IKnmRemark';
import { apiGet, apiPost, apiPut } from '../../MainModule/common/apiTools';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';

export async function fetchKnmRemarks(): Promise<IKnmRemark[]> {
  return apiGet<IKnmRemark[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-remarks`);
}

export async function fetchKnmRemarksAll(): Promise<IKnmRemark[]> {
  return apiGet<IKnmRemark[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-remarks/all`);
}

export async function createKnmRemark(data: Partial<IKnmRemark>): Promise<void> {
  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-remarks`, body: data });
}

export async function updateKnmRemark(data: Partial<IKnmRemark>): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-remarks/${data.id}`, data);
}
